import { useTranslation } from 'react-i18next';
import { IoIosArrowBack } from 'react-icons/io';
import { Link } from 'react-router-dom';

import Button from 'components/Buttons';

import * as Styled from './Card.styles';

type Props = {
  curved?: boolean;
  backButtonLink?: string;
  hideBackButton?: boolean;
  padding?: 'large' | 'medium' | 'small';
  children: React.ReactNode;
  style?: React.CSSProperties;
};

const Card = ({ backButtonLink, hideBackButton, padding, children, curved, style }: Props) => {
  const { t } = useTranslation();
  return (
    <>
      {!hideBackButton && (
        <Link to={backButtonLink ? backButtonLink : '/home'}>
          <Button type="text" $uppercase icon={<IoIosArrowBack />}>
            {t('nav.back')}
          </Button>
        </Link>
      )}
      <Styled.Card
        $padding={padding}
        $hideBackButton={hideBackButton}
        $curved={curved}
        style={style}
      >
        {children}
      </Styled.Card>
    </>
  );
};

export default Card;
